import { render, staticRenderFns } from "./RelationTableList.vue?vue&type=template&id=be204bc0&scoped=true"
import script from "./RelationTableList.vue?vue&type=script&lang=js"
export * from "./RelationTableList.vue?vue&type=script&lang=js"
import style0 from "./RelationTableList.vue?vue&type=style&index=0&id=be204bc0&prod&lang=scss&scoped=true"
import style1 from "./RelationTableList.vue?vue&type=style&index=1&id=be204bc0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be204bc0",
  null
  
)

export default component.exports